import { render, staticRenderFns } from "./form-container.vue?vue&type=template&id=fa047950&scoped=true&"
import script from "./form-container.vue?vue&type=script&lang=js&"
export * from "./form-container.vue?vue&type=script&lang=js&"
import style0 from "./form-container.vue?vue&type=style&index=0&id=fa047950&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa047950",
  null
  
)

export default component.exports